import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const EditPricing = (user: UserLoginType, id: string, size: string, price: string, bookbinding_price: string, is_multi_color: boolean) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `pricing/${id}`,
      body: JSON.stringify(
        {
          size: size,
          price: price,
          bookbinding_price: bookbinding_price,
          is_multi_color: is_multi_color
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};
